module.exports = __webpack_public_path__ + "img/service-5.731c1907.png";